import type { JSX } from 'react'

export const SelectedFavoriteIcon = (): JSX.Element => (
  <use href='#selectedFavoriteIcon' height='100%' width='100%' />
)
